var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.998,
    height: 40.01,
    viewBox: "0 0 39.998 40.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.25 -1.244)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 10.232,
    cy: 10.232,
    r: 10.232,
    transform: "translate(10.087 1.244)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M20.565,13.938a6.628,6.628,0,1,0,6.629,6.627A6.63,6.63,0,0,0,20.565,13.938Zm0,2.791a3.837,3.837,0,1,1-3.838,3.836A3.84,3.84,0,0,1,20.565,16.729Z",
    transform: "translate(10.917 10.922)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    "data-name": "Path 3369",
    d: "M19.541,16.784V13.645a1.4,1.4,0,1,0-2.791,0v3.14a1.4,1.4,0,1,0,2.791,0Z",
    transform: "translate(13.336 9.469)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    d: "M21.12,18.17l2.219-2.221a1.394,1.394,0,1,0-1.972-1.972L19.146,16.2A1.4,1.4,0,0,0,21.12,18.17Z",
    transform: "translate(15.047 10.604)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    d: "M20.956,19.541H24.1a1.4,1.4,0,0,0,0-2.791h-3.14a1.4,1.4,0,0,0,0,2.791Z",
    transform: "translate(15.756 13.341)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M19.146,21.12l2.221,2.219a1.394,1.394,0,1,0,1.972-1.972L21.12,19.146a1.4,1.4,0,0,0-1.974,1.974Z",
    transform: "translate(15.047 15.053)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3373",
    "data-name": "Path 3373",
    d: "M16.75,20.957V24.1a1.4,1.4,0,0,0,2.791,0v-3.14a1.4,1.4,0,0,0-2.791,0Z",
    transform: "translate(13.336 15.761)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3374",
    "data-name": "Path 3374",
    d: "M16.2,19.146l-2.219,2.221a1.394,1.394,0,0,0,1.972,1.972L18.17,21.12A1.4,1.4,0,0,0,16.2,19.146Z",
    transform: "translate(10.599 15.053)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    "data-name": "Path 3375",
    d: "M16.784,16.75H13.645a1.4,1.4,0,1,0,0,2.791h3.138a1.4,1.4,0,1,0,0-2.791Z",
    transform: "translate(9.464 13.341)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3376",
    "data-name": "Path 3376",
    d: "M18.17,16.2l-2.221-2.219a1.394,1.394,0,0,0-1.972,1.972L16.2,18.17A1.4,1.4,0,0,0,18.17,16.2Z",
    transform: "translate(10.599 10.604)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3377",
    "data-name": "Path 3377",
    d: "M22.991,29.2a3.258,3.258,0,0,1,.27-4.3l.361-.363H23.11a3.256,3.256,0,1,1,0-6.511h.512l-.361-.363a3.255,3.255,0,0,1-.145-4.448c-.912-.071-1.846-.108-2.8-.108-6.18,0-11.652,1.546-15.049,3.862-2.592,1.767-4.02,4.013-4.02,6.37v2.7A3.163,3.163,0,0,0,4.413,29.2Z",
    transform: "translate(0 10.206)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminViewIcon);
export default __webpack_public_path__ + "static/media/admin_view_icon.6fc11a8a83b0a226a69b93f7ed957158.svg";
export { ForwardRef as ReactComponent };